"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./TrainerCard.scss");
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TrainerCard = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    header,
    name,
    country,
    region,
    link,
    Link
  } = content;
  return /*#__PURE__*/_react.default.createElement("article", {
    className: "sum-trainer-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sum-trainer-card__content"
  }, header && /*#__PURE__*/_react.default.createElement("h5", {
    className: "sum-trainer-card__header"
  }, header), name && /*#__PURE__*/_react.default.createElement("p", {
    className: "sum-trainer-card__name"
  }, name), country && /*#__PURE__*/_react.default.createElement("p", {
    className: "sum-trainer-card__country"
  }, country, ","), region && /*#__PURE__*/_react.default.createElement("p", {
    className: "sum-trainer-card__region"
  }, region)), link && /*#__PURE__*/_react.default.createElement(_Button.default, {
    Link: Link ? Link : null,
    className: "ter-button--primary--1",
    text: link.text,
    url: link.url
  }));
};
var _default = TrainerCard;
exports.default = _default;